import { render, staticRenderFns } from "./OtsRosterDetailsPage.vue?vue&type=template&id=5c4339dc&"
import script from "./OtsRosterDetailsPage.vue?vue&type=script&lang=ts&"
export * from "./OtsRosterDetailsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c4339dc')) {
      api.createRecord('5c4339dc', component.options)
    } else {
      api.reload('5c4339dc', component.options)
    }
    module.hot.accept("./OtsRosterDetailsPage.vue?vue&type=template&id=5c4339dc&", function () {
      api.rerender('5c4339dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/340th/Student/OtsRosterDetailsPage.vue"
export default component.exports